import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {
    fetchFranchises,
    FranchiseListItem
} from "../franchiseSlice";
import {RequestStatus} from "../../../../api/apiConfiguration";
import {showErrorToastNotification, showSuccessToastNotification} from "../../../elements/toastNotification/toastNotificationSlice";
import {FranchiseForm} from "./FranchiseForm";
import {
    clearUpdateFranchiseState,
    prepareUpdateFranchiseRequest,
    updateFranchise,
    updateFranchiseRequestSelector,
    updateFranchiseRequestStatusSelector,
    updateUpdateFranchiseRequest
} from "../franchiseUpdateSlice";

interface Props {
    handleClose: () => void;
    franchise: FranchiseListItem;
}

export const UpdateFranchiseForm: React.FC<Props> = ({handleClose, franchise}) => {
    const dispatch = useAppDispatch();
    const status = useAppSelector(updateFranchiseRequestStatusSelector);

    useEffect(() => {
        dispatch(fetchFranchises());
        dispatch(prepareUpdateFranchiseRequest(franchise));
        return () => {
            dispatch(clearUpdateFranchiseState());
        }
    }, [dispatch, franchise]);

    useEffect(() => {
        if (status === RequestStatus.RESOLVED) {
            dispatch(fetchFranchises());
            dispatch(showSuccessToastNotification({message: "Franchise Updated Successfully"}));
            handleClose();
        } else if (status === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message: "Failed to save franchise"}));
        }
    }, [dispatch, handleClose, status]);

    const onSubmit = () => {
        if (status !== RequestStatus.PENDING) {
            dispatch(updateFranchise());
        }
    }

    return <FranchiseForm
        title={"Update franchise"}
        onClose={handleClose}
        onSubmit={onSubmit}
        requestSelector={updateFranchiseRequestSelector}
        updateRequest={updateUpdateFranchiseRequest}
    />
}
